/* eslint-disable max-len */
import {useEffect, useRef} from 'react';
import {useIntl} from 'react-intl';
import {useRouteMatch} from 'react-router-dom';
import classNames from 'classnames';
import * as store from '@/store';
import {tocRouters} from '@/config/routers';
import {setDocumentTitle} from '@/utils/browserUtils';
import Logo from '../Logo';
import {
    placeholderElMinWidth,
    IAdapterData,
    shrinkPlaceholderEl,
    hideLogoTitle,
    setIsRepositoryPage,
} from './widthAdapter';

import styles from './index.module.scss';
import AvatarDropMenu from '../AvatarDropMenu';
import Icon from '@/components/Icon';
import {ArrowRightSvg} from '@/icons';

export interface ISlots {
    left?: (data: IAdapterData) => React.ReactElement | null;
    right?: (data: IAdapterData) => React.ReactElement | null;
}

interface HeaderProps {
    className?: string;
    curRepository?: Repository;
    curRepositoryName?: string;
    headerSlot?: ISlots | null;
    headerAdapterData?: IAdapterData;
    curDocuments?: WizDocument[];
    rootElRef?: React.MutableRefObject<HTMLDivElement | null>;
}

function Header(props: HeaderProps) {
    const {
        curRepository,
        curRepositoryName,
        className,
        headerSlot,
        headerAdapterData = {},
        rootElRef,
        curDocuments,
    } = props;
    const intl = useIntl();
    const isHome = !!useRouteMatch({path: tocRouters.Welcome.path, exact: true}); // 是否首页

    function getCurRepositoryName() {
        if (curRepository && curRepository.name) {
            return curRepository.name;
        }
        return curRepositoryName || '';
    }
    const repoName = getCurRepositoryName();
    const isShowRepositoryName = !isHome && repoName && curDocuments && curDocuments?.length > 0;

    useEffect(() => {
        setIsRepositoryPage(!isHome);
    }, [isHome]);

    const placeholderElRef = useRef<HTMLDivElement | null>(null);

    if (isHome) {
        setDocumentTitle(null, intl);
    }

    return (
        <div ref={rootElRef} className={classNames(styles.header, className)}>
            <Logo showTitle={isHome && !headerAdapterData[hideLogoTitle]} />
            {
                isShowRepositoryName && <div className={styles.repositoryName}>
                    <Icon svg={ArrowRightSvg} className={styles.arrow} noSpace />
                    <span className={styles.name}>
                        {repoName}
                    </span>
                </div>
            }
            {headerSlot?.left ? headerSlot.left(headerAdapterData) : null}
            <div
                ref={placeholderElRef}
                className={classNames(styles.placeholder, 'header_center_placeholder')}
                style={{minWidth: headerAdapterData[shrinkPlaceholderEl] ? 0 : placeholderElMinWidth}}
                data-adapter-event-name={shrinkPlaceholderEl}
            ></div>
            {headerSlot?.right ? headerSlot.right(headerAdapterData) : null}

            <AvatarDropMenu />
        </div>
    );
}

const HeaderImpl = store.connect([
    store.KEYS.CUR_DEPARTMENT,
    store.KEYS.CUR_REPOSITORY,
    store.KEYS.CUR_REPOSITORY_NAME,
    store.KEYS.CUR_PAGE,
    store.KEYS.CUR_DOCUMENT,
    store.KEYS.DIRECTORY_EDIT,
    store.KEYS.CUR_DOCUMENT_ERROR,
    store.KEYS.CUR_DOCUMENTS,
])(Header);

export default HeaderImpl;
